import { useRouter } from 'next/router';
import EcoTextTc from 'eco-design/sections/eco-text-tc';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function Comp() {
    const { locale } = useRouter();
    const { t } = useLang('theProduct.FooterTcA');

    const items = [
        {
            isHead: true,
            title: t('header'),
        },
        {
            title: `<a href='https://www.horowitzresearch.com/research/market-analysis-of-solar-battery-systems-in-the-u-s/'>${t('titleA1')}</a>`,
        },
    ];

    return (
        <>
            <EcoTextTc items={items} className={styles.comp} />
        </>
    );
}
